// libs
import styled from "styled-components";

// dls
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const StyledProductItem = styled(CardContainer)(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing.xSmall,
}));

export const ProductImageContainer = styled.div(() => ({
    flexShrink: 0,
}));

export const StyledImage = styled(Image)(({ theme }) => ({
    width: "50px",
    height: "50px",
    objectFit: "cover",
    background: theme.colors[theme.colorMode].background_Secondary,
    borderRadius: theme.cornerRadius.xSmall,
}));

export const ProductDetailsContainer = styled.div(({ theme }) => ({
    flex: 1,
    margin: `0 ${theme.spacing.xSmall}`,
}));

export const ProductPricingContainer = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-end",
}));

export const StrikeThroughText = styled(Text)(({ theme }) => ({
    textDecoration: "line-through",
    marginBottom: theme.spacing.xxxSmall,
}));
